// @flow

import React from "react";
import { localize } from "redux-i18n";
import { SimpleGrid, WistiaPlayer } from "@components";

type Props = PropsFromLocalize;

class HelpPanelWellbeingAdvice extends React.Component<Props> {
  get categoriesData() {
    return [
      {
        id: "illness",
        label: this.props.t("ILLNESS"),
        details: this.props.t("WELLBEING_ILLNESS_DESCRIPTION"),
      },
      {
        id: "mind",
        label: this.props.t("MIND"),
        details: this.props.t("WELLBEING_MIND_DESCRIPTION"),
      },
      {
        id: "allergies",
        label: this.props.t("ALLERGIES"),
        details: this.props.t("WELLBEING_ALLERGIES_DESCRIPTION"),
      },
      {
        id: "crisis",
        label: this.props.t("CRISIS"),
        details: this.props.t("WELLBEING_CRISIS_DESCRIPTION"),
      },
      {
        id: "wellness",
        label: this.props.t("WELLNESS"),
        details: this.props.t("WELLBEING_WELLNESS_DESCRIPTION"),
      },
    ];
  }

  get recommendationsData() {
    return [
      {
        id: "engagement",
        label: this.props.t("ENCOURAGE_ENGAGEMENT"),
        details: this.props.t("WELLBEING_ENCOURAGE_ENGAGEMENT_DESCRIPTION"),
      },
      {
        id: "communication",
        label: this.props.t("MENTAL_HEALTH_SUPPORT"),
        details: this.props.t("WELLBEING_MENTAL_HEALTH_SUPPORT_DESCRIPTION"),
      },
    ];
  }

  get columns() {
    return [
      {
        title: this.props.t("ITEM"),
        name: "setting",
        width: 110,
        renderItem: item => item.label,
      },
      {
        title: this.props.t("DESCRIPTION"),
        name: "details",
        renderItem: item => item.details,
      },
    ];
  }

  get recommendationsColumns() {
    return [
      {
        title: this.props.t("ITEM"),
        name: "setting",
        width: 110,
        renderItem: item => item.label,
        columnClassName: "bg-mint",
      },
      {
        title: this.props.t("DESCRIPTION"),
        name: "details",
        renderItem: item => item.details,
      },
    ];
  }

  render() {
    return (
      <div>
        <p className="fs-14">{this.props.t("WELLBEING_ADVICE_INTRODUCTION")}</p>
        <h6 className="font-weight-bold">{this.props.t("TUTORIAL")}</h6>
        <div className="mb-3">
          <WistiaPlayer
            videoId={WistiaPlayer.videos.WELLBEING_ADVICE_INSTRUCTIONS}
            title={this.props.t("WELLBEING_ADVICE_INSTRUCTIONS")}
          />
        </div>
        <h6 className="font-weight-bold">{this.props.t("ADVICE_CATEGORIES")}</h6>
        <SimpleGrid className="theme-help" columns={this.columns} rows={this.categoriesData} />
        <h6 className="font-weight-bold">{this.props.t("RECOMMENDATIONS")}</h6>
        <SimpleGrid
          className="theme-help"
          columns={this.recommendationsColumns}
          rows={this.recommendationsData}
        />
      </div>
    );
  }
}

export default localize()(HelpPanelWellbeingAdvice);
